(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuya-avis"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAvis(root) {
      if (root.nuyaReady) return;
      root.nuyaReady = true;

      /* Visionneuse : ouverte par n'importe quelle vignette de la section. */
      var viewer = root.querySelector('[data-nuya-avis-viewer]');
      var stage = root.querySelector('[data-nuya-avis-viewer-stage]');

      function closeViewer() {
        if (!viewer) return;
        viewer.classList.remove('is-open');
        viewer.hidden = true;
        if (stage) stage.innerHTML = '';
        document.documentElement.style.removeProperty('overflow');
      }

      function openViewer(url, type) {
        if (!viewer || !stage || !url) return;
        stage.innerHTML = '';

        var node;
        if (type === 'video') {
          node = document.createElement('video');
          node.src = url;
          node.controls = true;
          node.autoplay = true;
          node.playsInline = true;
        } else {
          node = document.createElement('img');
          node.src = url;
          node.alt = '';
        }

        stage.appendChild(node);
        viewer.hidden = false;
        viewer.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
      }

      root.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-nuya-avis-media]');
        if (thumb) {
          openViewer(thumb.dataset.nuyaAvisMedia, thumb.dataset.nuyaAvisMediaType);
          return;
        }

        if (event.target.closest('[data-nuya-avis-viewer-close]') ||
            event.target === viewer) {
          closeViewer();
          return;
        }

        var button = event.target.closest('[data-nuya-avis-page]');
        if (!button) return;

        var page = button.dataset.nuyaAvisPage;

        root.querySelectorAll('[data-nuya-avis-item]').forEach(function (item) {
          item.hidden = item.dataset.page !== page;
        });

        root.querySelectorAll('[data-nuya-avis-page]').forEach(function (other) {
          other.classList.toggle('is-active', other === button);
          other.setAttribute('aria-current', other === button ? 'true' : 'false');
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && viewer && !viewer.hidden) closeViewer();
      });

      /* Formulaire : la liste des produits ne s'ouvre que si la cliente
         accepte de les montrer, et seuls les modèles cochés partent dans
         l'e-mail. */
      var consent = root.querySelector('[data-nuya-avis-consent]');
      var bought = root.querySelector('[data-nuya-avis-bought]');
      var carrier = root.querySelector('[data-nuya-avis-products]');

      if (consent && bought && carrier) {
        var collect = function () {
          if (!consent.checked) {
            carrier.value = '';
            return;
          }

          var picked = [];
          bought.querySelectorAll('[data-nuya-avis-product]').forEach(function (box) {
            if (box.checked) picked.push(box.value);
          });
          carrier.value = picked.join(', ');
        };

        consent.addEventListener('change', function () {
          bought.hidden = !consent.checked;
          collect();
        });

        bought.addEventListener('change', collect);
      }
    }

    function run(scope) {
      (scope || document).querySelectorAll('[data-nuya-avis]').forEach(initAvis);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        run(document);
      });
    } else {
      run(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      run(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuya-cart-drawer"]) return;
  try {
    
  (function () {
    function initCartDrawer(root) {
      if (root.nuyaCartReady) return;
      root.nuyaCartReady = true;

      var sectionId = 'nuya-cart-drawer';
      var busy = false;
      var pendingRefresh = null;

      function inner() {
        return root.querySelector('[data-nuya-cart-inner]');
      }

      function setBusy(state) {
        busy = state;
        var node = inner();
        if (node) node.setAttribute('data-busy', state ? 'true' : 'false');
      }

      function rootUrl() {
        return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      }

      /* Rafraîchit le contenu du panneau via l'API Section Rendering :
         tous les prix et textes restent rendus côté Liquid, dans la bonne
         langue et la bonne devise. */
      function refresh() {
        if (pendingRefresh) return pendingRefresh;

        pendingRefresh = fetch(rootUrl() + '?section_id=' + sectionId, { headers: { Accept: 'text/html' } })
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-nuya-cart-inner]');
            var current = inner();
            if (fresh && current) {
              current.replaceWith(fresh);
              highlightRecommendedSize();
              syncGift();
            }
          })
          .catch(function () {})
          .finally(function () {
            pendingRefresh = null;
          });

        return pendingRefresh;
      }

      /* ------------------------------------------------------------------
         Voile offert — inscrit sur la ligne du burkini comme propriété
         (ex. « Voile offert : Voile de bain — Noir »). Il voyage donc
         jusqu'à la commande pour la préparation, sans jamais entrer dans
         le calcul du prix. Rien n'est ajouté comme article payant.
         ------------------------------------------------------------------ */
      var giftSyncing = false;

      /* Le thème n'ajoute JAMAIS un cadeau tout seul : il se contente de
         retirer le surplus quand le palier redescend, et d'inscrire le voile
         assorti sur la ligne du burkini. Le panier est la seule source de
         vérité, aucun choix n'est mémorisé ailleurs.
         Une seule opération par ligne : change.js remplace toutes les
         propriétés d'un coup, deux opérations sur la même ligne se
         piétineraient. */
      function syncGift() {
        if (giftSyncing) return Promise.resolve();

        var veils = {};
        root.querySelectorAll('[data-nuya-gift-source]').forEach(function (item) {
          var key = item.dataset.giftKey;
          if (!key) return;
          veils[key] = { name: item.dataset.giftProperty, value: item.dataset.giftValue };
        });

        /* Les paliers sont lus sur le conteneur rafraîchi, jamais sur la
           racine : celle-ci garde les valeurs du chargement de page.
           Sans palier configuré, le thème ne touche à aucune ligne offerte
           (un tote ajouté depuis la page produit resterait). */
        var host = inner() || root;
        var managed = host.dataset.giftManaged === 'true';
        var slots = parseInt(host.dataset.giftSlots, 10) || 0;

        giftSyncing = true;

        return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            var updates = {};
            var removals = [];

            /* Copie de travail des propriétés d'une ligne. */
            function draft(item) {
              if (!updates[item.key]) {
                var copy = {};
                Object.keys(item.properties || {}).forEach(function (name) {
                  copy[name] = item.properties[name];
                });
                updates[item.key] = { quantity: item.quantity, properties: copy };
              }
              return updates[item.key];
            }

            /* Surplus de cadeaux : le palier a baissé (burkini retiré) et le
               panier en contient plus que de places. On rogne en partant du
               dernier ajouté. Nouvelle quantité par ligne dans « trim ». */
            var trim = {};
            if (managed) {
              var gifts = cart.items.filter(function (item) {
                return (item.properties || {})._cadeau === 'true';
              });

              var surplus = gifts.reduce(function (total, item) {
                return total + item.quantity;
              }, 0) - slots;

              for (var index = gifts.length - 1; index >= 0 && surplus > 0; index--) {
                var drop = Math.min(gifts[index].quantity, surplus);
                surplus -= drop;
                trim[gifts[index].key] = gifts[index].quantity - drop;
              }
            }

            cart.items.forEach(function (item) {
              var properties = item.properties || {};

              /* Nettoyage des cadeaux ajoutés comme articles payants par une
                 version précédente : ils fausseraient le total. */
              if (properties._offert === 'true') {
                removals.push(item.key);
                return;
              }

              if (properties._cadeau === 'true') {
                if (Object.prototype.hasOwnProperty.call(trim, item.key)) {
                  draft(item).quantity = trim[item.key];
                }
                return;
              }

              /* Sélection écrite en propriété par la version précédente :
                 elle n'a plus lieu d'être, le cadeau est une vraie ligne. */
              if (properties._totes) {
                var stale = draft(item);
                delete stale.properties._totes;
                Object.keys(stale.properties).forEach(function (name) {
                  if (name.toLowerCase().indexOf('tote bag offert') === 0) delete stale.properties[name];
                });
              }

              var veil = veils[item.key];
              if (veil && properties[veil.name] !== veil.value) {
                draft(item).properties[veil.name] = veil.value;
              }
            });

            var operations = removals.map(function (key) {
              return { id: key, quantity: 0 };
            });
            Object.keys(updates).forEach(function (key) {
              operations.push({
                id: key,
                quantity: updates[key].quantity,
                properties: updates[key].properties,
              });
            });

            if (!operations.length) {
              giftSyncing = false;
              return;
            }

            /* Une requête à la fois : l'API panier refuse le parallèle. */
            var chain = Promise.resolve();
            operations.forEach(function (operation) {
              chain = chain.then(function () {
                return fetch(rootUrl() + 'cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify(operation),
                });
              });
            });

            return chain.then(function () {
              giftSyncing = false;
              if (window.Nuya && window.Nuya.cart) window.Nuya.cart.refresh();
              return refresh();
            });
          })
          .catch(function () {
            giftSyncing = false;
          });
      }

      /* Ajout d'un cadeau : uniquement sur clic du visiteur, une pièce par
         clic. La variante ajoutée est celle à 0 € du tote choisi, marquée
         « _cadeau » pour que le panier la reconnaisse. */
      function addGift(variantId) {
        if (busy || !variantId) return;
        setBusy(true);

        fetch(rootUrl() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1, properties: { _cadeau: 'true' } }],
          }),
        })
          .then(function (response) {
            if (!response.ok) throw new Error('gift_add_failed');
            return response.json();
          })
          .then(function () {
            if (window.Nuya && window.Nuya.cart) window.Nuya.cart.refresh();
            return refresh();
          })
          .catch(function () {
            return refresh();
          })
          .finally(function () {
            setBusy(false);
          });
      }

      /* La taille recommandée par le NUYA FIT est mise en avant dans
         la suggestion de produit. Rien n'est stocké au-delà de la session. */
      function highlightRecommendedSize() {
        var wanted = '';
        try {
          wanted = (window.sessionStorage.getItem('nuya:fit:size') || '').toLowerCase();
        } catch (error) {
          wanted = '';
        }
        if (!wanted) return;

        root.querySelectorAll('[data-nuya-upsell-sizes]').forEach(function (group) {
          var target = null;
          group.querySelectorAll('[data-nuya-upsell-variant]').forEach(function (chip) {
            if ((chip.dataset.size || '').toLowerCase() === wanted && !chip.disabled) target = chip;
          });
          if (target) selectSize(group, target);
        });
      }

      function selectSize(group, chip) {
        group.querySelectorAll('[data-nuya-upsell-variant]').forEach(function (other) {
          other.classList.toggle('is-active', other === chip);
          other.setAttribute('aria-pressed', other === chip ? 'true' : 'false');
        });
        var card = group.closest('[data-nuya-upsell]');
        var add = card ? card.querySelector('[data-nuya-upsell-add]') : null;
        if (add) add.dataset.variant = chip.dataset.nuyaUpsellVariant;
      }

      /* « payload » cible soit un rang (line), soit une clé de ligne (id) :
         les lignes cadeau sont désignées par clé, car leur rang change au
         gré des ajouts. */
      function changeLine(payload) {
        if (busy) return;
        setBusy(true);

        fetch(rootUrl() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        })
          .then(function (response) {
            if (!response.ok) throw new Error('cart_change_failed');
            return response.json();
          })
          .then(function () {
            if (window.Nuya && window.Nuya.cart) window.Nuya.cart.refresh();
            return refresh();
          })
          .catch(function () {
            return refresh();
          })
          .finally(function () {
            setBusy(false);
          });
      }

      /* Délégation : le contenu est remplacé à chaque rafraîchissement. */
      root.addEventListener('click', function (event) {
        var change = event.target.closest('[data-nuya-line-change]');
        if (change) {
          event.preventDefault();
          var quantity = Math.max(0, parseInt(change.dataset.quantity, 10) || 0);

          if (change.dataset.key) {
            changeLine({ id: change.dataset.key, quantity: quantity });
          } else {
            changeLine({ line: parseInt(change.dataset.line, 10), quantity: quantity });
          }
          return;
        }

        var chip = event.target.closest('[data-nuya-upsell-variant]');
        if (chip && !chip.disabled) {
          event.preventDefault();
          selectSize(chip.closest('[data-nuya-upsell-sizes]'), chip);
          return;
        }

        /* Choix d'un tote bag offert : ajout immédiat au panier, une pièce
           par clic, dans la limite des places du palier. Le même modèle peut
           être pris plusieurs fois. */
        var toteChoice = event.target.closest('[data-nuya-tote-choice]');
        if (toteChoice && !toteChoice.disabled) {
          event.preventDefault();

          var host = inner();
          var slots = host ? parseInt(host.dataset.giftSlots, 10) || 0 : 0;
          var taken = host ? parseInt(host.dataset.giftTaken, 10) || 0 : 0;
          if (taken >= slots) return;

          addGift(parseInt(toteChoice.dataset.variant, 10));
          return;
        }

        var add = event.target.closest('[data-nuya-upsell-add]');
        if (add && window.Nuya && window.Nuya.cart) {
          event.preventDefault();
          if (busy) return;
          setBusy(true);
          window.Nuya.cart
            .add(parseInt(add.dataset.variant, 10), 1)
            .finally(function () {
              setBusy(false);
            });
        }
      });

      /* Le panneau s'ouvre automatiquement après chaque ajout au panier,
         d'où qu'il vienne. */
      document.addEventListener('nuya:cart:added', function () {
        refresh().then(function () {
          if (window.Nuya && window.Nuya.panels) window.Nuya.panels.open(root);
        });
      });

      /* Ajouts venant des composants du thème de base (pages produit). */
      document.addEventListener('cart:update', function () {
        refresh();
      });

      /* Un rafraîchissement du contenu au premier affichage suffit :
         le HTML initial est rendu par Liquid. */
      root.addEventListener('nuya:panel:open', highlightRecommendedSize);
      highlightRecommendedSize();
      syncGift();
    }

    function run(scope) {
      (scope || document).querySelectorAll('[data-nuya-cart-drawer]').forEach(initCartDrawer);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        run(document);
      });
    } else {
      run(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      run(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuya-collection"]) return;
  try {
    
  (function () {
    function initCollection(root) {
      if (root.nuyaReady) return;
      root.nuyaReady = true;

      var form = root.querySelector('[data-nuya-collection-form]');
      if (!form) return;

      /* Le tri s'applique dès le choix ; les filtres attendent « Appliquer »
         pour éviter un rechargement à chaque case cochée. */
      var sort = form.querySelector('[data-nuya-sort]');
      if (sort) {
        sort.addEventListener('change', function () {
          form.submit();
        });
      }

      /* Le panneau de filtres se referme au clic extérieur et avec Échap. */
      var filters = form.querySelector('[data-nuya-filters]');
      if (!filters) return;

      document.addEventListener('click', function (event) {
        if (!filters.open) return;
        if (filters.contains(event.target)) return;
        filters.open = false;
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && filters.open) filters.open = false;
      });
    }

    function run(scope) {
      (scope || document).querySelectorAll('[data-nuya-collection]').forEach(initCollection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        run(document);
      });
    } else {
      run(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      run(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuya-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Brouillon conservé le temps d'un aller-retour serveur : Shopify ne
       renvoie que l'e-mail et le message, prénom et nom seraient perdus. */
    var DRAFT_KEY = 'nuya:contact:draft';

    function readDraft() {
      try {
        var raw = sessionStorage.getItem(DRAFT_KEY);
        sessionStorage.removeItem(DRAFT_KEY);
        return raw ? JSON.parse(raw) : null;
      } catch (error) {
        return null;
      }
    }

    function saveDraft(form) {
      var draft = {};
      form.querySelectorAll('[data-nuya-contact-keep]').forEach(function (field) {
        if (field.id) draft[field.id] = field.value;
      });

      try {
        sessionStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
      } catch (error) {
        /* Navigation privée : on se passe du brouillon. */
      }
    }

    function restoreDraft(form, failed) {
      var draft = readDraft();
      if (!draft || !failed) return;

      Object.keys(draft).forEach(function (id) {
        var field = document.getElementById(id);
        /* Les champs déjà remplis par Liquid ont la priorité. */
        if (field && form.contains(field) && !field.value) field.value = draft[id];
      });
    }

    /* Le message de retour est amené sous l'en-tête, puis reçoit le focus
       pour être annoncé aux lecteurs d'écran. */
    function revealFeedback(feedback) {
      var styles = getComputedStyle(document.documentElement);
      var header = parseInt(styles.getPropertyValue('--nuya-header-h'), 10) || 0;
      var offset = header + 24;
      var reduced = window.Nuya && window.Nuya.prefersReducedMotion && window.Nuya.prefersReducedMotion();

      if (window.Nuya && window.Nuya.lenis) {
        window.Nuya.lenis.scrollTo(feedback, { offset: -offset, immediate: !!reduced });
      } else {
        var top = feedback.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: Math.max(top, 0), behavior: reduced ? 'auto' : 'smooth' });
      }

      try {
        feedback.focus({ preventScroll: true });
      } catch (error) {
        feedback.focus();
      }
    }

    /* Après un envoi, Shopify laisse ?contact_posted=true dans l'URL :
       on le retire pour qu'un rechargement ne réaffiche pas le message. */
    function cleanUrl() {
      if (!window.history || !history.replaceState || typeof URLSearchParams === 'undefined') return;
      if (window.location.search.indexOf('contact_posted') === -1) return;

      var params = new URLSearchParams(window.location.search);
      params.delete('contact_posted');
      var query = params.toString();
      history.replaceState({}, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
    }

    function initContact(root) {
      if (root.nuyaContactReady) return;
      root.nuyaContactReady = true;

      var form = root.querySelector('#nuya-contact-form');
      var feedback = root.querySelector('[data-nuya-contact-feedback]');
      var failed = !!feedback && feedback.getAttribute('data-nuya-contact-feedback') === 'error';

      if (feedback) {
        revealFeedback(feedback);
        cleanUrl();
      }

      if (!form) return;

      restoreDraft(form, failed);

      var submit = form.querySelector('[data-nuya-contact-submit]');
      var hiddenName = form.querySelector('[data-nuya-contact-name]');
      var first = form.querySelector('#nuya-contact-first');
      var last = form.querySelector('#nuya-contact-last');

      form.addEventListener('submit', function () {
        /* Le navigateur bloque l'envoi tant qu'un champ requis est vide :
           inutile de verrouiller le bouton dans ce cas. */
        if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;

        if (hiddenName) {
          hiddenName.value = [first ? first.value.trim() : '', last ? last.value.trim() : '']
            .filter(Boolean)
            .join(' ');
        }

        saveDraft(form);

        if (!submit) return;

        submit.setAttribute('aria-busy', 'true');

        var sending = submit.getAttribute('data-label-sending');
        if (sending) submit.textContent = sending;

        /* Désactiver dans la foulée annulerait l'envoi : on attend que le
           navigateur ait pris la main. */
        setTimeout(function () {
          submit.disabled = true;
        }, 0);
      });

      /* Retour arrière depuis le cache : le bouton doit redevenir cliquable. */
      window.addEventListener('pageshow', function (event) {
        if (!event.persisted || !submit) return;
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      });
    }

    if (window.Nuya && window.Nuya.onSection) {
      window.Nuya.onSection('[data-nuya-contact]', initContact);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('[data-nuya-contact]').forEach(initContact);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuya-cookies"]) return;
  try {
    
  (function () {
    function initCookies(root) {
      if (root.nuyaReady) return;
      root.nuyaReady = true;

      var CATEGORIES = ['analytics', 'marketing', 'preferences'];

      /* Mémoire du choix, côté navigateur. `shouldShowBanner()` de l'API
         Shopify redéclare le bandeau à chaque page tant que le consentement
         n'est pas enregistré de son côté (région hors périmètre, API lente
         à charger, appel refusé…). Ce drapeau tranche : une fois que la
         cliente a cliqué accepter OU refuser, le bandeau ne revient plus. */
      var CHOICE_KEY = 'nuya:cookies:choice';
      var rememberDays = parseInt(root.dataset.rememberDays, 10);
      if (isNaN(rememberDays)) rememberDays = 0;

      function readChoice() {
        try {
          var raw = window.localStorage.getItem(CHOICE_KEY);
          if (!raw) return null;
          var saved = JSON.parse(raw);
          if (!saved || !saved.at) return null;

          /* 0 jour = choix gardé sans limite. */
          if (rememberDays > 0) {
            var age = (Date.now() - saved.at) / 86400000;
            if (age > rememberDays) return null;
          }
          return saved;
        } catch (error) {
          return null;
        }
      }

      function writeChoice(choice) {
        try {
          window.localStorage.setItem(CHOICE_KEY, JSON.stringify({ at: Date.now(), choice: choice }));
        } catch (error) {
          /* stockage indisponible : on retombe sur l'API Shopify seule */
        }
      }
      var prefs = root.querySelector('[data-nuya-cookies-prefs]');
      var toggle = root.querySelector('[data-nuya-cookies-toggle]');

      if (root.dataset.hideNative === 'true') {
        document.body.dataset.nuyaCookies = 'true';
      }

      function show() {
        root.hidden = false;
        /* Deux images d'écart : le panneau part de sa position basse avant de
           monter, sinon la transition ne se joue pas. */
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            root.dataset.open = 'true';
          });
        });
      }

      function hide() {
        root.dataset.open = 'false';
        window.setTimeout(function () {
          root.hidden = true;
        }, 260);
      }

      function api() {
        return window.Shopify && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null;
      }

      /* L'API n'est pas chargée par défaut : on la demande, puis on décide si
         le bandeau doit s'afficher pour cette région. */
      function withApi(callback) {
        if (api()) {
          callback(api());
          return;
        }

        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
          callback(null);
          return;
        }

        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function (error) {
            callback(error ? null : api());
          }
        );
      }

      function record(choice) {
        writeChoice(choice);
        withApi(function (privacy) {
          if (privacy && typeof privacy.setTrackingConsent === 'function') {
            privacy.setTrackingConsent(choice, function () {});
          }
        });
        hide();
      }

      function acceptAll() {
        record({ analytics: true, marketing: true, preferences: true, sale_of_data: true });
      }

      function declineAll() {
        record({ analytics: false, marketing: false, preferences: false, sale_of_data: false });
      }

      function saveChoice() {
        var choice = { sale_of_data: false };

        CATEGORIES.forEach(function (name) {
          var box = root.querySelector('[data-nuya-cookies-cat="' + name + '"]');
          choice[name] = box ? box.checked : false;
        });

        choice.sale_of_data = choice.marketing;
        record(choice);
      }

      root.addEventListener('click', function (event) {
        if (event.target.closest('[data-nuya-cookies-accept]')) acceptAll();
        if (event.target.closest('[data-nuya-cookies-decline]')) declineAll();
        if (event.target.closest('[data-nuya-cookies-save]')) saveChoice();

        if (toggle && event.target.closest('[data-nuya-cookies-toggle]')) {
          var open = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (prefs) prefs.hidden = open;
        }
      });

      /* Aperçu dans l'éditeur de thème : le bandeau reste visible même si le
         consentement est déjà donné, sinon il serait impossible à régler. */
      if (root.dataset.force === 'true' && window.Shopify && window.Shopify.designMode) {
        show();
        return;
      }

      /* Choix déjà fait : on ne redemande rien, sur aucune page. */
      if (readChoice()) return;

      withApi(function (privacy) {
        if (!privacy) return;
        if (typeof privacy.shouldShowBanner === 'function' && !privacy.shouldShowBanner()) return;
        show();
      });
    }

    function run(scope) {
      (scope || document).querySelectorAll('[data-nuya-cookies]').forEach(initCookies);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        run(document);
      });
    } else {
      run(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      run(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuya-country-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCountry(root) {
      if (root.nuyaReady) return;
      root.nuyaReady = true;

      var localeInputs = root.querySelectorAll('[data-nuya-locale-input]');
      var countryInput = root.querySelector('[data-nuya-country-input]');
      var selects = root.querySelectorAll('[data-nuya-select]');

      selects.forEach(function (select) {
        var trigger = select.querySelector('[data-nuya-select-trigger]');
        var options = select.querySelector('[data-nuya-select-options]');
        if (!trigger || !options) return;

        function close() {
          trigger.setAttribute('aria-expanded', 'false');
          options.hidden = true;
        }

        trigger.addEventListener('click', function () {
          var open = trigger.getAttribute('aria-expanded') === 'true';
          selects.forEach(function (other) {
            if (other === select) return;
            var otherTrigger = other.querySelector('[data-nuya-select-trigger]');
            var otherOptions = other.querySelector('[data-nuya-select-options]');
            if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
            if (otherOptions) otherOptions.hidden = true;
          });

          trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
          options.hidden = open;
        });

        /* Chaque option renseigne pays et langue avant l'envoi du formulaire. */
        options.querySelectorAll('.nuya-country__option').forEach(function (option) {
          option.addEventListener('click', function () {
            var country = option.getAttribute('data-nuya-country');
            var locale = option.getAttribute('data-nuya-locale');

            if (country && countryInput) countryInput.value = country;

            /* Pas de langue connue pour cette destination : on ne l'envoie pas
               du tout, Shopify choisit la langue par défaut du marché. */
            localeInputs.forEach(function (input) {
              input.disabled = !locale;
              if (locale) input.value = locale;
            });
          });
        });

        document.addEventListener('click', function (event) {
          if (!select.contains(event.target)) close();
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') close();
        });
      });
    }

    function run(scope) {
      (scope || document).querySelectorAll('[data-nuya-country]').forEach(initCountry);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        run(document);
      });
    } else {
      run(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      run(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuya-cross-sell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCross(root) {
      if (root.nuyaReady) return;
      root.nuyaReady = true;

      /* Les flèches sont dans l'en-tête, la piste plus bas : on initialise
         sur la section entière pour que le helper trouve les deux. */
      if (window.Nuya) window.Nuya.initCarousel(root);
    }

    function run(scope) {
      (scope || document).querySelectorAll('[data-nuya-cross]').forEach(initCross);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        run(document);
      });
    } else {
      run(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      run(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuya-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      if (root.nuyaFaqReady) return;
      root.nuyaFaqReady = true;

      var links = root.querySelectorAll('[data-nuya-faq-nav-link]');
      var groups = root.querySelectorAll('[data-nuya-faq-group]');
      if (!links.length || !groups.length || !window.IntersectionObserver) return;

      function activate(id) {
        links.forEach(function (link) {
          link.classList.toggle('is-active', link.getAttribute('data-nuya-faq-nav-link') === id);
        });
      }

      /* Rubrique en cours de lecture : la plus haute de celles qui touchent
         la bande sous l'en-tête. */
      var visible = {};

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            visible[entry.target.getAttribute('data-nuya-faq-group')] = entry.isIntersecting;
          });

          for (var i = 0; i < groups.length; i++) {
            var id = groups[i].getAttribute('data-nuya-faq-group');
            if (visible[id]) {
              activate(id);
              return;
            }
          }
        },
        { rootMargin: '-25% 0px -60% 0px', threshold: 0 }
      );

      groups.forEach(function (group) {
        observer.observe(group);
      });
    }

    function run(scope) {
      (scope || document).querySelectorAll('[data-nuya-faq]').forEach(initFaq);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        run(document);
      });
    } else {
      run(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      run(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuya-fit-drawer"]) return;
  try {
    
  (function () {
    function initFit(root) {
      if (root.nuyaFitReady) return;
      root.nuyaFitReady = true;

      var TOTAL = 5;
      var current = 1;
      var result = null;
      var timers = [];

      var tallMin = parseInt(root.dataset.tallMin, 10) || 175;
      var greyMin = parseInt(root.dataset.greyMin, 10) || 172;
      var smallMax = parseInt(root.dataset.smallMax, 10) || 159;
      var pantCurvyMin = parseInt(root.dataset.pantCurvyMin, 10) || 43;

      var progress = root.querySelector('[data-nuya-fit-progress]');
      var back = root.querySelector('[data-nuya-fit-back]');
      var restart = root.querySelector('[data-nuya-fit-restart]');
      var heightInput = root.querySelector('[data-nuya-fit-height]');
      var weightInput = root.querySelector('[data-nuya-fit-weight]');
      var pantsInput = root.querySelector('[data-nuya-fit-pants]');
      var heightValue = root.querySelector('[data-nuya-fit-height-value]');
      var weightValue = root.querySelector('[data-nuya-fit-weight-value]');
      var pantsValue = root.querySelector('[data-nuya-fit-pants-value]');
      var body = root.querySelector('.nuya-fit__body');

      /* Collecte anonyme vers Google Sheet (Apps Script). Aucune donnée
         personnelle : pas d'email, un identifiant de session aléatoire.
         Valeurs enregistrées en français quelle que soit la langue du site. */
      var sheetUrl = root.dataset.sheetUrl || '';
      var lastSent = '';
      var MORPHO_FR = { 1: 'Plus plat', 2: 'Normal', 3: 'Plus rond' };
      var RESULT_FR = {
        small: 'Cas 1 · Standard (petite taille)',
        normal: 'Cas 2 · Standard',
        curvy: 'Cas 3 · Standard (grande taille pantalon)',
        grey: 'Cas 4 · Zone grise',
        tall: 'Cas 5 · Tall',
        tall_curvy: 'Cas 6 · Tall (grande taille pantalon)'
      };
      var LENGTH_FR = {
        small: 'Standard',
        normal: 'Standard',
        curvy: 'Standard',
        grey: 'À choisir',
        tall: 'Tall',
        tall_curvy: 'Tall'
      };

      function sessionId() {
        try {
          var id = window.sessionStorage.getItem('nuya:fit:sid');
          if (!id) {
            id = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
            window.sessionStorage.setItem('nuya:fit:sid', id);
          }
          return id;
        } catch (error) {
          return '';
        }
      }

      function sendToSheet(res) {
        if (!sheetUrl || !res) return;

        var morpho = root.querySelector('[data-nuya-fit-choice][aria-checked="true"]');
        var untouched = [];
        if (heightInput && !heightInput.dataset.touched) untouched.push('Taille');
        if (weightInput && !weightInput.dataset.touched) untouched.push('Poids');
        if (pantsInput && !pantsInput.dataset.touched) untouched.push('Pantalon');

        var data = {
          'Langue': (root.dataset.locale || 'fr').toUpperCase(),
          'ID session': sessionId(),
          'Taille (cm)': heightInput ? parseInt(heightInput.value, 10) : '',
          'Poids (kg)': weightInput ? parseInt(weightInput.value, 10) : '',
          'Taille pantalon': pantsInput ? parseInt(pantsInput.value, 10) : '',
          'Morphologie': morpho
            ? MORPHO_FR[morpho.dataset.nuyaFitChoice] || morpho.dataset.nuyaFitChoice
            : 'Non renseignée',
          'Résultat': RESULT_FR[res.key] || res.key,
          'Longueur recommandée': LENGTH_FR[res.key] || '',
          'Jauge (/10)': res.gauge,
          'Curseurs non touchés': untouched.length ? untouched.join(', ') : 'Aucun',
          'Page': root.dataset.pageType || '',
          'Produit': root.dataset.product || '',
          'Appareil': window.matchMedia('(max-width: 749px)').matches ? 'Mobile' : 'Ordinateur'
        };

        /* Pas de doublon si elle revient en arrière sans rien changer. */
        var signature = JSON.stringify(data);
        if (signature === lastSent) return;
        lastSent = signature;

        try {
          fetch(sheetUrl, {
            method: 'POST',
            mode: 'no-cors',
            keepalive: true,
            headers: { 'Content-Type': 'text/plain' },
            body: signature
          }).catch(function () {});
        } catch (error) {
          /* envoi impossible : sans conséquence pour la cliente */
        }
      }

      function screens() {
        return root.querySelectorAll('[data-nuya-fit-screen]');
      }

      function clearTimers() {
        timers.forEach(window.clearTimeout);
        timers = [];
      }

      /* Remplissage de la barre par écran. Sur le résultat, la barre
         redevient neutre : seul RECOMMENCER reste au-dessus (maquette). */
      var PROGRESS = { 1: 12, 2: 33, 3: 66, 4: 66, 5: 0 };

      function show(step) {
        clearTimers();
        current = step;

        screens().forEach(function (screen) {
          screen.hidden = screen.getAttribute('data-nuya-fit-screen') !== String(step);
        });

        if (progress) progress.style.width = (PROGRESS[step] || 0) + '%';
        if (back) back.hidden = step === 1 || step === 4;
        if (restart) restart.hidden = step !== 5;
        if (body) body.scrollTop = 0;

        if (step === 4) runAnalysis();
        if (step === 5) renderResult();
      }

      /* Curseurs — valeur affichée + remplissage de la piste */
      function syncRange(input, valueNode) {
        if (!input) return;
        var min = parseFloat(input.min);
        var max = parseFloat(input.max);
        var value = parseFloat(input.value);
        input.style.setProperty('--fill', ((value - min) / (max - min)) * 100 + '%');
        if (valueNode) valueNode.textContent = input.value;
      }

      var VALUE_NODES = [
        [heightInput, heightValue],
        [weightInput, weightValue],
        [pantsInput, pantsValue]
      ];

      VALUE_NODES.forEach(function (pair) {
        var input = pair[0];
        var valueNode = pair[1];
        if (!input) return;
        syncRange(input, valueNode);
        input.addEventListener('input', function () {
          input.dataset.touched = '1';
          syncRange(input, valueNode);
        });
      });

      /* Morphologie — ne modifie pas le résultat (guide, partie 05) */
      root.querySelectorAll('[data-nuya-fit-choice]').forEach(function (choice) {
        choice.addEventListener('click', function () {
          root.querySelectorAll('[data-nuya-fit-choice]').forEach(function (other) {
            other.setAttribute('aria-checked', other === choice ? 'true' : 'false');
          });
        });
      });

      /* Cartes produit du résultat : choix de taille + ajout au panier. */
      function selectSize(group, chip) {
        group.querySelectorAll('[data-nuya-fit-variant]').forEach(function (other) {
          other.classList.toggle('is-active', other === chip);
          other.setAttribute('aria-pressed', other === chip ? 'true' : 'false');
        });
        var card = group.closest('[data-nuya-fit-prod]');
        var add = card ? card.querySelector('[data-nuya-fit-add]') : null;
        if (add) add.dataset.variant = chip.dataset.nuyaFitVariant;
      }

      root.addEventListener('click', function (event) {
        var chip = event.target.closest('[data-nuya-fit-variant]');
        if (chip && !chip.disabled) {
          selectSize(chip.closest('[data-nuya-fit-sizes]'), chip);
          return;
        }

        var add = event.target.closest('[data-nuya-fit-add]');
        if (add && !add.disabled && window.Nuya && window.Nuya.cart) {
          add.dataset.loading = 'true';
          /* On ferme le NUYA FIT : le panier s'ouvre par-dessus la page. */
          if (window.Nuya.panels) window.Nuya.panels.close(root);
          window.Nuya.cart
            .add(parseInt(add.dataset.variant, 10), 1)
            .catch(function () {})
            .then(function () {
              add.dataset.loading = 'false';
            });
        }
      });

      /* La logique (référentiel tailles). Deux entrées, jamais le poids ni la
         morphologie :

         · la TAILLE en centimètres choisit la longueur — standard ou Tall ;
         · la TAILLE DE PANTALON choisit le discours — au-delà du seuil
           (pantCurvyMin, 43 par défaut) la matière travaille en extension,
           le tombé est plus près du corps qu'une coupe oversize.

           taille >= tallMin (175)  + pantalon < 43  -> tall
           taille >= tallMin (175)  + pantalon >= 43 -> tall_curvy
           taille 172–174           (zone grise)     -> grey
           taille <= 171            + pantalon >= 43 -> curvy
           taille <= smallMax (159) + pantalon < 43  -> small
           taille 160–171           + pantalon < 43  -> normal

         La zone grise reste la zone grise quelle que soit la taille de
         pantalon : elle ne décrit pas une coupe mais un choix entre deux
         longueurs, que l'extension de la matière ne tranche pas. */
      function computeResult() {
        var height = heightInput ? parseInt(heightInput.value, 10) : 165;
        var pants = pantsInput ? parseInt(pantsInput.value, 10) : 0;
        var curvy = !isNaN(pants) && pants >= pantCurvyMin;
        var key;

        if (height >= tallMin) key = curvy ? 'tall_curvy' : 'tall';
        else if (height >= greyMin) key = 'grey';
        else if (curvy) key = 'curvy';
        else if (height <= smallMax) key = 'small';
        else key = 'normal';

        var gauge = 7; /* ample */
        if (key === 'small') gauge = 9; /* très ample */
        else if (curvy && key !== 'grey') gauge = 5; /* standard, plus près du corps */

        return { key: key, gauge: gauge };
      }

      function runAnalysis() {
        result = computeResult();

        var steps = root.querySelectorAll('[data-nuya-fit-step]');
        var rail = root.querySelector('[data-nuya-fit-steps]');
        var thinking = root.querySelector('[data-nuya-fit-thinking]');

        steps.forEach(function (step) {
          step.classList.remove('is-done');
          step.classList.remove('is-active');
        });
        if (rail) rail.style.setProperty('--nuya-fit-fill', '0%');
        if (thinking) thinking.hidden = false;

        /* Temps de réflexion simulé : le résultat est déjà calculé, l'attente
           sert à donner à voir un système qui analyse. Réglable dans
           l'éditeur, et supprimée si la cliente demande moins d'animations. */
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var stepDuration = parseInt(root.dataset.stepDuration, 10);
        if (isNaN(stepDuration)) stepDuration = 900;

        var jitter = parseInt(root.dataset.stepJitter, 10);
        if (isNaN(jitter)) jitter = 0;

        var finalPause = parseInt(root.dataset.finalPause, 10);
        if (isNaN(finalPause)) finalPause = 800;

        if (reduce) {
          stepDuration = 0;
          jitter = 0;
          finalPause = 0;
        }

        if (rail) rail.style.setProperty('--nuya-fit-fill-speed', stepDuration + 'ms');

        /* Chaque étape dure un peu plus ou un peu moins que la précédente :
           un rythme parfaitement régulier trahit une simple minuterie. */
        function slice() {
          if (!stepDuration || !jitter) return stepDuration;
          var spread = (Math.random() * 2 - 1) * (jitter / 100);
          return Math.max(120, Math.round(stepDuration * (1 + spread)));
        }

        var elapsed = 0;

        steps.forEach(function (step, index) {
          var start = elapsed;
          elapsed += slice();

          timers.push(
            window.setTimeout(function () {
              step.classList.add('is-active');
            }, start)
          );

          timers.push(
            window.setTimeout(function () {
              step.classList.remove('is-active');
              step.classList.add('is-done');

              /* Les deux barres montent ensemble jusqu'à 100 % : la barre
                 horizontale du panneau et le rail vertical des étapes. */
              var ratio = Math.round(((index + 1) / steps.length) * 100);
              if (progress) progress.style.width = ratio + '%';
              if (rail) rail.style.setProperty('--nuya-fit-fill', ratio + '%');
            }, elapsed)
          );
        });

        timers.push(
          window.setTimeout(function () {
            if (thinking) thinking.hidden = true;
            show(5);
          }, elapsed + finalPause)
        );
      }

      function renderResult() {
        if (!result) result = computeResult();
        sendToSheet(result);

        root.querySelectorAll('[data-nuya-fit-case]').forEach(function (block) {
          block.hidden = block.getAttribute('data-nuya-fit-case') !== result.key;
        });

        /* Jauge */
        var gauge = root.querySelector('[data-nuya-fit-gauge]');
        if (gauge) {
          gauge.querySelectorAll('.nuya-fit__gauge-seg').forEach(function (segment, index) {
            segment.classList.toggle('is-on', index < result.gauge);
          });

          var label = 'ample';
          if (result.gauge >= 9) label = 'very-ample';
          else if (result.gauge <= 3) label = 'adjusted';
          else if (result.gauge <= 5) label = 'standard';

          gauge.querySelectorAll('[data-gauge-label]').forEach(function (node) {
            node.classList.toggle('is-current', node.getAttribute('data-gauge-label') === label);
          });
        }

        /* Taille recommandée sélectionnée sur chaque carte produit */
        var isTall = result.key === 'tall' || result.key === 'tall_curvy';
        var sizeValue = isTall ? root.dataset.sizeValueTall : root.dataset.sizeValueUnique;
        root.querySelectorAll('[data-nuya-fit-sizes]').forEach(function (group) {
          var chips = group.querySelectorAll('[data-nuya-fit-variant]');
          var target = null;

          chips.forEach(function (chip) {
            if ((chip.dataset.size || '').toLowerCase() === (sizeValue || '').toLowerCase() && !chip.disabled) {
              target = chip;
            }
          });
          if (!target) {
            chips.forEach(function (chip) {
              if (!target && !chip.disabled) target = chip;
            });
          }
          if (target) selectSize(group, target);
        });

        /* Partagé avec la suggestion du panier — session uniquement. */
        try {
          if (result.key === 'grey') window.sessionStorage.removeItem('nuya:fit:size');
          else window.sessionStorage.setItem('nuya:fit:size', (sizeValue || '').toLowerCase());
        } catch (error) {
          /* stockage indisponible : sans conséquence */
        }

        var carousel = root.querySelector('[data-nuya-fit-carousel]');
        if (carousel && window.Nuya && window.Nuya.initCarousel) window.Nuya.initCarousel(carousel);
      }

      root.querySelectorAll('[data-nuya-fit-go]').forEach(function (button) {
        button.addEventListener('click', function () {
          show(parseInt(button.getAttribute('data-nuya-fit-go'), 10));
        });
      });

      if (back) {
        back.addEventListener('click', function () {
          if (current > 1) show(current - 1);
        });
      }

      if (restart) {
        restart.addEventListener('click', function () {
          result = null;
          show(2);
        });
      }

      root.addEventListener('nuya:panel:close', clearTimers);
    }

    function run(scope) {
      (scope || document).querySelectorAll('[data-nuya-fit]').forEach(initFit);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        run(document);
      });
    } else {
      run(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      run(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuya-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeader(header) {
      if (header.nuyaReady) return;
      header.nuyaReady = true;

      var group = document.getElementById('header-group');
      var mega = header.querySelector('[data-nuya-mega]');
      var triggers = header.querySelectorAll('[data-nuya-mega-trigger]');
      var closeTimer = null;

      if (group) {
        group.classList.toggle('nuya-header-group--transparent', header.dataset.transparent === 'true');
      }

      function onScroll() {
        header.dataset.scrolled = window.scrollY > 8 ? 'true' : 'false';
      }

      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });

      if (!mega) return;

      function openMega() {
        window.clearTimeout(closeTimer);
        mega.hidden = false;
        /* La barre passe en opaque le temps que le panneau est déroulé. */
        header.dataset.megaOpen = 'true';
        window.requestAnimationFrame(function () {
          mega.dataset.open = 'true';
        });
        triggers.forEach(function (trigger) {
          trigger.setAttribute('aria-expanded', 'true');
        });
      }

      function closeMega(immediate) {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(
          function () {
            mega.dataset.open = 'false';
            header.dataset.megaOpen = 'false';
            triggers.forEach(function (trigger) {
              trigger.setAttribute('aria-expanded', 'false');
            });
            window.setTimeout(function () {
              if (mega.dataset.open !== 'true') mega.hidden = true;
            }, 220);
          },
          immediate ? 0 : 120
        );
      }

      var isDesktop = function () {
        return window.matchMedia('(min-width: 990px)').matches;
      };

      triggers.forEach(function (trigger) {
        trigger.addEventListener('mouseenter', function () {
          if (isDesktop()) openMega();
        });

        /* Le lien qui ouvre le mega-menu ne navigue jamais : clic = bascule. */
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          if (mega.dataset.open === 'true') closeMega(true);
          else openMega();
        });

        trigger.addEventListener('mouseleave', function () {
          if (isDesktop()) closeMega();
        });

        trigger.addEventListener('focus', openMega);
      });

      mega.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
      });

      mega.addEventListener('mouseleave', function () {
        if (isDesktop()) closeMega();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeMega(true);
      });

      document.addEventListener('click', function (event) {
        if (!header.contains(event.target)) closeMega(true);
      });
    }

    function run(scope) {
      (scope || document).querySelectorAll('[data-nuya-header]').forEach(initHeader);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        run(document);
      });
    } else {
      run(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      run(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuya-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Hauteur utile : on retranche ce qui occupe déjà le haut de la fenêtre
       (barre d'annonce, en-tête non transparent) pour que le bas du hero —
       donc l'indice « Découvrir » — reste dans le premier écran.
       Ne s'applique que si le hero est bien la première section : au-delà
       d'un demi-écran, l'offset n'a plus de sens. */
    /* Sous 750 px la pastille est à cheval sur la section suivante : le hero
       doit s'arrêter une demi-pastille plus haut. Au-dessus, le bouton est à
       l'intérieur et le hero va jusqu'au bas de l'écran. */
    var mqStraddle = window.matchMedia('(max-width: 749px)');

    function measureHero(hero) {
      var hint = hero.querySelector('[data-nuya-hero-scroll]');
      var half = hint ? Math.round(hint.offsetHeight / 2) : 0;

      hero.style.setProperty('--nuya-scroll-half', half + 'px');
      hero.style.setProperty('--nuya-hero-extra', '0px');
      hero.style.setProperty('--nuya-hero-pad-b', '');
      hero.style.setProperty('--nuya-hero-offset', '0px');

      /* Ce qui occupe déjà le haut de la fenêtre (barre d'annonce, en-tête
         non transparent). Au-delà d'un demi-écran le hero n'est pas la
         première section : l'offset n'a plus de sens. */
      var top = hero.getBoundingClientRect().top + window.scrollY;
      if (top > 0 && top <= window.innerHeight / 2) {
        hero.style.setProperty('--nuya-hero-offset', Math.round(top) + 'px');
      }

      if (!hint) return;

      /* Le calcul ci-dessus suppose que la hauteur imposée fait la loi. Elle
         ne la fait pas toujours : `min-height` est un plancher, pas un
         plafond — un contenu haut (grand titre, image de titre) pousse le
         hero au-delà du premier écran et emporte le bouton avec lui. On
         corrige donc sur la position RÉELLEMENT rendue. */
      var extra = 0;
      var padBottom = 120;
      /* Marge à réserver sous le hero : la demi-pastille en mode à cheval,
         rien quand le bouton est à l'intérieur. */
      var reserve = mqStraddle.matches ? half : 0;

      for (var pass = 0; pass < 4; pass++) {
        var over = Math.round(
          hero.getBoundingClientRect().bottom + window.scrollY + reserve - window.innerHeight
        );
        if (over <= 1) break;

        var before = hero.offsetHeight;
        extra += over;
        hero.style.setProperty('--nuya-hero-extra', extra + 'px');

        /* Hauteur bloquée par le contenu : rogner la hauteur imposée ne
           change rien, c'est le rembourrage bas qu'il faut reprendre. */
        if (hero.offsetHeight >= before) {
          padBottom = Math.max(24, padBottom - over);
          hero.style.setProperty('--nuya-hero-pad-b', padBottom + 'px');
        }
      }

      /* Le trait vertical central s'arrête au niveau de l'indice
         « Découvrir » : on mesure une fois la hauteur définitive posée. */
      var heroRect = hero.getBoundingClientRect();
      var hintRect = hint.getBoundingClientRect();
      hero.style.setProperty(
        '--nuya-hero-line-b',
        Math.max(0, Math.round(heroRect.bottom - (hintRect.top + hintRect.height / 2))) + 'px'
      );
    }

    function measureAll() {
      document.querySelectorAll('.nuya-hero').forEach(measureHero);
    }

    function initHero(hero) {
      if (hero.nuyaReady) return;
      hero.nuyaReady = true;

      measureHero(hero);
      /* La barre d'annonce et l'en-tête peuvent changer de hauteur après le
         chargement des polices : on remesure. */
      window.addEventListener('load', function () {
        measureHero(hero);
      });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          measureHero(hero);
        });
      }

      var trigger = hero.querySelector('[data-nuya-hero-scroll]');
      if (!trigger) return;

      /* Le libellé « Découvrir » change de gabarit quand la police de la
         boutique arrive, et d'une langue à l'autre après traduction : tant
         que le bouton n'a pas sa taille finale, la demi-hauteur retranchée
         est fausse et sa moitié basse repasse sous la ligne de flottaison.
         On remesure donc à chaque changement de gabarit du bouton. */
      if (window.ResizeObserver) {
        new window.ResizeObserver(function () {
          measureHero(hero);
        }).observe(trigger);
      }

      trigger.addEventListener('click', function () {
        var section = hero.closest('.shopify-section');
        var next = section ? section.nextElementSibling : null;
        var top = next ? next.getBoundingClientRect().top + window.scrollY : window.innerHeight;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (window.Nuya && window.Nuya.lenis) {
          window.Nuya.lenis.scrollTo(top, { duration: reduce ? 0 : 1.1 });
        } else {
          window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        }
      });
    }

    function run(scope) {
      (scope || document).querySelectorAll('.nuya-hero').forEach(initHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        run(document);
      });
    } else {
      run(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      run(event.target);
      measureAll();
    });

    window.addEventListener('resize', measureAll);
    document.addEventListener('shopify:section:unload', measureAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuya-instagram-mosaic"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* On duplique le groupe jusqu'à couvrir deux fois la largeur d'écran,
       puis on cale le décalage de l'animation sur la largeur réelle d'un
       groupe. La durée se déduit de la vitesse : le défilement garde la
       même allure quel que soit le nombre de médias. */
    function initSocial(root) {
      if (root.nuyaSocialReady) return;
      root.nuyaSocialReady = true;

      var track = root.querySelector('[data-nuya-social-track]');
      var group = root.querySelector('[data-nuya-social-group]');
      if (!track || !group) return;

      var speed = parseInt(root.dataset.speed, 10) || 60;

      function measure() {
        var groupWidth = group.getBoundingClientRect().width;
        if (!groupWidth) return;

        var needed = Math.max(2, Math.ceil((window.innerWidth * 2) / groupWidth) + 1);
        var current = track.querySelectorAll('[data-nuya-social-group]').length;

        for (var i = current; i < needed; i++) {
          var clone = group.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        }

        track.style.setProperty('--nuya-social-shift', '-' + groupWidth + 'px');
        track.style.setProperty('--nuya-social-duration', groupWidth / speed + 's');
      }

      measure();
      window.addEventListener('resize', measure);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

      /* Les médias chargent en différé : on remesure à leur arrivée. */
      root.querySelectorAll('img').forEach(function (image) {
        if (!image.complete) image.addEventListener('load', measure, { once: true });
      });
    }

    function run(scope) {
      (scope || document).querySelectorAll('[data-nuya-social]').forEach(initSocial);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        run(document);
      });
    } else {
      run(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      run(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuya-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTabs(root) {
      if (root.nuyaReady) return;
      root.nuyaReady = true;

      var tabs = root.querySelectorAll('[data-nuya-tab]');
      var panels = root.querySelectorAll('[data-nuya-panel-id]');

      panels.forEach(function (panel) {
        if (window.Nuya) window.Nuya.initCarousel(panel);
      });

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.getAttribute('data-nuya-tab');

          tabs.forEach(function (item) {
            item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
          });

          panels.forEach(function (panel) {
            var active = panel.getAttribute('data-nuya-panel-id') === id;
            panel.hidden = !active;
            if (active && panel.nuyaUpdateArrows) panel.nuyaUpdateArrows();
          });
        });
      });
    }

    function run(scope) {
      (scope || document).querySelectorAll('[data-nuya-tabs]').forEach(initTabs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        run(document);
      });
    } else {
      run(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      run(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuya-product"]) return;
  try {
    
  (function () {
    function initProduct(root) {
      if (root.nuyaReady) return;
      root.nuyaReady = true;

      /* Lien « X avis », à côté des étoiles : défilement doux jusqu'à la
         section des avis de la page. Lenis quand il tourne (desktop),
         `scrollTo` natif sinon (mobile), et saut sec si la cliente a
         demandé moins d'animations. */
      root.querySelectorAll('.nuya-product__rating-link').forEach(function (link) {
        link.addEventListener('click', function (event) {
          var hash = link.getAttribute('href') || '';
          if (hash.charAt(0) !== '#') return;

          var target = document.querySelector(hash);
          if (!target) return;

          event.preventDefault();

          var headerH = parseInt(
            getComputedStyle(document.documentElement).getPropertyValue('--nuya-header-h'),
            10
          ) || 72;
          var offset = headerH + 16;
          var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (!calm && window.Nuya && window.Nuya.lenis) {
            /* L'easing par défaut de Lenis (exponentiel) avale 40 % de la
               distance dans les 80 premières millisecondes : ça se voit comme
               un saut. Ici une courbe symétrique, qui démarre doucement,
               accélère au milieu et freine à l'arrivée. */
            window.Nuya.lenis.scrollTo(target, {
              offset: -offset,
              duration: 1.4,
              easing: function (t) {
                return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
              },
            });
            return;
          }

          var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: top, behavior: calm ? 'auto' : 'smooth' });
        });
      });

      var data = root.querySelector('[data-nuya-variants]');
      var variants = [];
      try {
        variants = JSON.parse(data.textContent);
      } catch (error) {
        variants = [];
      }

      /* Carte cadeau : la vignette prend une image au hasard parmi celles de
         la collection. Le tirage est fait ici et non en Liquid — le cache de
         page figerait un hasard calculé côté serveur. */
      root.querySelectorAll('[data-nuya-gift-thumbs]').forEach(function (holder) {
        var urls = (holder.dataset.nuyaGiftThumbs || '').split('|').filter(Boolean);
        var image = holder.querySelector('img');
        if (urls.length < 2 || !image) return;
        image.src = urls[Math.floor(Math.random() * urls.length)];
      });

      var priceNode = root.querySelector('[data-nuya-price]');
      var compareNode = root.querySelector('[data-nuya-compare]');
      var saveNode = root.querySelector('[data-nuya-save]');
      var stockLine = root.querySelector('[data-nuya-stock-line]');
      var addButton = root.querySelector('[data-nuya-product-add]');
      var addLabel = root.querySelector('[data-nuya-add-label]');
      var selected = variants.length ? variants[0] : null;

      /* Variante courante = croisement des options choisies. */
      function currentOptions() {
        var values = [];
        root.querySelectorAll('[data-option-index]').forEach(function (group) {
          var active = group.querySelector('.nuya-product__swatch.is-active');
          values[parseInt(group.dataset.optionIndex, 10)] = active ? active.dataset.value : null;
        });
        return values;
      }

      function findVariant(values) {
        for (var i = 0; i < variants.length; i++) {
          var variant = variants[i];
          var match = true;
          for (var j = 0; j < values.length; j++) {
            if (values[j] && variant.options[j] !== values[j]) match = false;
          }
          if (match) return variant;
        }
        return null;
      }

      /* Format monétaire de la boutique : jamais de code devise en double. */
      function money(cents) {
        var value = cents / 100;
        var currency =
          window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR';

        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
            style: 'currency',
            currency: currency,
          }).format(value);
        } catch (error) {
          return value.toFixed(2);
        }
      }

      function activeBundle() {
        return root.querySelector('[data-nuya-bundle].is-active');
      }

      function render() {
        if (!selected) return;

        var bundle = activeBundle();
        var quantity = bundle ? parseInt(bundle.dataset.quantity, 10) || 1 : 1;
        var discount = bundle ? parseInt(bundle.dataset.discount, 10) || 0 : 0;
        var total = selected.price * quantity;
        if (discount > 0) total = Math.round((total * (100 - discount)) / 100);

        if (priceNode) priceNode.textContent = money(selected.price);

        var onSale = !!(selected.compare_at_price && selected.compare_at_price > selected.price);

        if (compareNode) {
          compareNode.hidden = !onSale;
          if (onSale) compareNode.textContent = money(selected.compare_at_price);
        }

        /* Pastille d'économie : pourcentage arrondi de la variante affichée. */
        if (saveNode) {
          saveNode.hidden = !onSale;
          if (onSale) {
            var percent = Math.round(
              ((selected.compare_at_price - selected.price) * 100) / selected.compare_at_price
            );
            saveNode.textContent = (saveNode.dataset.template || '').replace('[remise]', percent);
          }
        }

        /* Stock restant de la variante : vrai inventaire si le suivi est
           actif, sinon la valeur de repli renseignée en administration. */
        if (stockLine) {
          var left = 0;
          if (selected.inventory_management && selected.inventory_quantity > 0) {
            left = selected.inventory_quantity;
          }
          if (!left) left = parseInt(stockLine.dataset.fallback, 10) || 0;
          stockLine.innerHTML = (stockLine.dataset.template || '').replace('[stock]', left);
        }

        /* Les totaux, le prix à la pièce et la remise suivent la variante. */
        root.querySelectorAll('[data-nuya-bundle]').forEach(function (item) {
          var itemQuantity = parseInt(item.dataset.quantity, 10) || 1;
          var itemDiscount = parseInt(item.dataset.discount, 10) || 0;
          var fullTotal = selected.price * itemQuantity;
          var itemTotal = fullTotal;
          if (itemDiscount > 0) itemTotal = Math.round((fullTotal * (100 - itemDiscount)) / 100);

          var was = item.querySelector('[data-nuya-bundle-was]');
          var value = item.querySelector('[data-nuya-bundle-total]');
          var unit = item.querySelector('[data-nuya-bundle-unit]');
          var saved = item.querySelector('[data-nuya-bundle-saved]');

          if (was) was.textContent = money(fullTotal);
          if (value) value.textContent = money(itemTotal);
          if (unit) unit.textContent = money(Math.round(itemTotal / itemQuantity));
          if (saved) saved.textContent = money(fullTotal - itemTotal);
        });

        /* Un pack à composer bloque l'ajout au panier : tant que les pièces
           n'ont pas été choisies dans le configurateur, le bouton principal
           ajouterait un article seul au lieu du pack annoncé. */
        var needsCompose = !!(
          bundle &&
          quantity > 1 &&
          bundle.querySelector('[data-nuya-bundle-configure]') &&
          bundle.dataset.composed !== 'true'
        );

        if (addButton) {
          addButton.disabled = !selected.available || needsCompose;
          addButton.dataset.needsCompose = needsCompose ? 'true' : 'false';
        }

        if (addLabel) {
          if (!selected.available) {
            addLabel.textContent = root.dataset.soldLabel;
          } else if (needsCompose) {
            addLabel.textContent = root.dataset.composeLabel || root.dataset.addLabel;
          } else {
            addLabel.textContent = root.dataset.addLabel + ' · ' + money(total);
          }
        }

        /* L'URL suit la variante, comme sur une page produit standard. */
        if (window.history && window.history.replaceState && selected.id) {
          window.history.replaceState({}, '', root.dataset.url + '?variant=' + selected.id);
        }
      }

      root.addEventListener('click', function (event) {
        var swatch = event.target.closest('.nuya-product__swatch');
        /* La rangée « couleur » entre produits est faite de vrais liens :
           on les laisse naviguer, ils ne pilotent aucune variante. */
        if (swatch && swatch.closest('[data-nuya-color-group]')) return;
        if (swatch) {
          var group = swatch.closest('[data-option-index]');
          group.querySelectorAll('.nuya-product__swatch').forEach(function (other) {
            other.classList.toggle('is-active', other === swatch);
            other.setAttribute('aria-pressed', other === swatch ? 'true' : 'false');
          });

          var label = group.querySelector('[data-nuya-option-value]');
          if (label) label.textContent = swatch.dataset.value;

          var found = findVariant(currentOptions());
          if (found) selected = found;
          render();

          /* La galerie suit la couleur choisie — uniquement ici : ailleurs,
             elle doit rester sur le visuel que le visiteur regarde. */
          if (found && found.featured_media && gallery && gallery.showMediaById) {
            gallery.showMediaById(found.featured_media.id);
          }
          return;
        }

        var bundle = event.target.closest('[data-nuya-bundle]');
        if (bundle) {
          root.querySelectorAll('[data-nuya-bundle]').forEach(function (other) {
            other.classList.toggle('is-active', other === bundle);
            other.setAttribute('aria-checked', other === bundle ? 'true' : 'false');
          });
          render();
          return;
        }

        var tab = event.target.closest('[data-nuya-tab]');
        if (tab) {
          var id = tab.dataset.nuyaTab;
          root.querySelectorAll('[data-nuya-tab]').forEach(function (other) {
            other.setAttribute('aria-selected', other === tab ? 'true' : 'false');
          });
          root.querySelectorAll('[data-nuya-tab-panel]').forEach(function (panel) {
            panel.hidden = panel.dataset.nuyaTabPanel !== id;
          });
          return;
        }

        var add = event.target.closest('[data-nuya-product-add]');
        if (add && !add.disabled && selected && window.Nuya && window.Nuya.cart) {
          var activeBundleNode = activeBundle();
          var quantity = activeBundleNode ? parseInt(activeBundleNode.dataset.quantity, 10) || 1 : 1;

          add.disabled = true;
          window.Nuya.cart
            .add(selected.id, quantity)
            .catch(function () {})
            .then(function () {
              add.disabled = false;
            });
        }
      });

      /* Compte à rebours : heure limite de commande du jour, puis TRANCHE de
         livraison estimée (« 6 à 10 jours ») plutôt qu'une date précise. */
      var countdown = root.querySelector('[data-nuya-countdown]');
      if (countdown) {
        var cutoff = parseInt(root.dataset.cutoff, 10);
        var delay = parseInt(root.dataset.delay, 10) || 3;
        var delayMax = parseInt(root.dataset.delayMax, 10) || 0;

        var tick = function () {
          var now = new Date();
          var limit = new Date(now);
          limit.setHours(cutoff, 0, 0, 0);

          var extra = 0;
          if (now >= limit) {
            limit.setDate(limit.getDate() + 1);
            extra = 1;
          }

          var diff = limit - now;
          var hours = Math.floor(diff / 3600000);
          var minutes = Math.floor((diff % 3600000) / 60000);

          /* Passée l'heure limite, la commande part le lendemain : la tranche
             entière glisse d'un jour. */
          var minDays = delay + extra;
          var maxDays = delayMax + extra;

          var rangeText;
          if (delayMax > delay) {
            rangeText = root.dataset.deliveryRangeTemplate
              .replace('[min]', minDays)
              .replace('[max]', maxDays);
          } else {
            rangeText = root.dataset.deliverySingleTemplate.replace('[min]', minDays);
          }

          countdown.hidden = false;
          countdown.innerHTML = root.dataset.countdownTemplate
            .replace('[heures]', '<strong>' + hours + 'h' + ('0' + minutes).slice(-2) + 'min</strong>')
            .replace('[delai]', '<strong>' + rangeText + '</strong>')
            .replace('[date]', '<strong>' + rangeText + '</strong>');
        };

        tick();
        window.setInterval(tick, 30000);
      }

      /* ------------------------------------------------------------------
         Configurateur de pack : on choisit les pièces manquantes, puis le
         tote bag offert, puis tout part au panier en une fois.
         ------------------------------------------------------------------ */
      var modal = root.querySelector('[data-nuya-bundle-modal]');
      if (modal) {
        var needed = 0;
        var giftNeeded = 0;
        var stepNode = 1;

        var stepLabel = modal.querySelector('[data-nuya-bundle-step-label]');
        var stepTitle = modal.querySelector('[data-nuya-bundle-title]');
        var countNode = modal.querySelector('[data-nuya-bundle-count]');
        var backButton = modal.querySelector('[data-nuya-bundle-back]');
        var submitButton = modal.querySelector('[data-nuya-bundle-add]');

        function showStep(step) {
          stepNode = step;

          modal.querySelectorAll('[data-nuya-bundle-step]').forEach(function (panel) {
            panel.hidden = panel.dataset.nuyaBundleStep !== String(step);
          });

          if (backButton) backButton.hidden = step === 1;

          if (stepLabel) {
            stepLabel.textContent = (root.dataset.stepWord || 'Étape') + ' ' + step + '/' + (giftNeeded > 0 ? 2 : 1);
          }
          if (stepTitle) {
            stepTitle.textContent = step === 1 ? root.dataset.stepOneTitle : root.dataset.stepTwoTitle;
          }

          refreshState();
        }

        /* Les quantités vivent sur les cartes : un même modèle peut donc
           être pris plusieurs fois, dans des tailles différentes. */
        function cards(kind) {
          return modal.querySelectorAll('[data-nuya-bundle-card="' + kind + '"]');
        }

        function chosen(kind) {
          var list = [];
          cards(kind).forEach(function (card) {
            var quantity = parseInt(card.dataset.qty, 10) || 0;
            if (quantity > 0) {
              list.push({ id: parseInt(card.dataset.variant, 10), title: card.dataset.title, quantity: quantity });
            }
          });
          return list;
        }

        function total(kind) {
          var sum = 0;
          chosen(kind).forEach(function (entry) {
            sum += entry.quantity;
          });
          return sum;
        }

        function describe(kind) {
          return chosen(kind)
            .map(function (entry) {
              return entry.quantity > 1 ? entry.title + ' ×' + entry.quantity : entry.title;
            })
            .join(', ');
        }

        function refreshState() {
          var kind = stepNode === 1 ? 'piece' : 'gift';
          var target = stepNode === 1 ? needed : giftNeeded;
          var count = total(kind);

          /* Compteurs, pastilles et boutons + désactivés une fois le compte
             atteint : le client voit toujours où il en est. */
          cards(kind).forEach(function (card) {
            var quantity = parseInt(card.dataset.qty, 10) || 0;
            var value = card.querySelector('[data-nuya-bundle-qty]');
            var badge = card.querySelector('[data-nuya-bundle-badge]');
            var plus = card.querySelector('[data-nuya-bundle-plus]');
            var minus = card.querySelector('[data-nuya-bundle-minus]');

            if (value) value.textContent = quantity;
            if (badge) {
              badge.hidden = quantity === 0;
              badge.textContent = quantity;
            }
            if (plus) plus.disabled = count >= target;
            if (minus) minus.disabled = quantity === 0;
            card.classList.toggle('is-active', quantity > 0);
          });

          if (countNode) {
            var label = count + ' / ' + target;
            var detail = describe(kind);
            countNode.textContent = detail ? label + ' · ' + detail : label;
          }

          if (!submitButton) return;

          if (stepNode === 1 && giftNeeded > 0) {
            submitButton.textContent = root.dataset.nextWord || 'Continuer';
            submitButton.disabled = count < target;
          } else {
            submitButton.textContent = root.dataset.addLabel;
            submitButton.disabled = total('piece') < needed || total('gift') < giftNeeded;
          }
        }

        function renderSummary() {
          var active = activeBundle();
          if (!active) return;

          /* Pack composé et envoyé au panier : le bouton principal redevient
             disponible (il ajouterait alors une pièce seule, ce qui est un
             choix explicite du visiteur). */
          active.dataset.composed = 'true';
          render();

          var summary = active.querySelector('[data-nuya-bundle-summary]');
          if (!summary) return;

          var parts = [describe('piece'), describe('gift')].filter(Boolean);
          summary.textContent = parts.join(' · ');
        }

        function openModal() {
          var active = activeBundle();
          if (!active) return;

          needed = (parseInt(active.dataset.quantity, 10) || 1) - 1;
          giftNeeded = parseInt(active.dataset.gift, 10) || 0;

          modal.querySelectorAll('[data-nuya-bundle-card]').forEach(function (card) {
            card.dataset.qty = '0';
          });

          modal.hidden = false;
          document.body.classList.add('nuya-no-scroll');
          showStep(1);
        }

        function closeModal() {
          modal.hidden = true;
          document.body.classList.remove('nuya-no-scroll');
        }

        root.addEventListener('click', function (event) {
          var opener = event.target.closest('[data-nuya-bundle-configure]');
          if (opener) {
            event.preventDefault();
            event.stopPropagation();
            openModal();
          }
        });

        modal.addEventListener('click', function (event) {
          if (event.target.closest('[data-nuya-bundle-close]')) {
            closeModal();
            return;
          }

          var stepButton = event.target.closest('[data-nuya-bundle-plus], [data-nuya-bundle-minus]');
          if (stepButton && !stepButton.disabled) {
            var stepCard = stepButton.closest('[data-nuya-bundle-card]');
            var current = parseInt(stepCard.dataset.qty, 10) || 0;
            var delta = stepButton.hasAttribute('data-nuya-bundle-plus') ? 1 : -1;

            stepCard.dataset.qty = Math.max(0, current + delta);
            refreshState();
            return;
          }

          if (event.target.closest('[data-nuya-bundle-back]')) {
            showStep(1);
            return;
          }

          var submit = event.target.closest('[data-nuya-bundle-add]');
          if (submit && !submit.disabled) {
            if (stepNode === 1 && giftNeeded > 0) {
              showStep(2);
              return;
            }

            var items = [{ id: selected.id, quantity: 1 }];

            chosen('piece').forEach(function (entry) {
              items.push({ id: entry.id, quantity: entry.quantity });
            });

            /* Les cadeaux partent au panier comme vraies lignes à 0 €,
               marquées « _cadeau » : le panier les reconnaît comme choix du
               visiteur et ne les remplace pas. */
            chosen('gift').forEach(function (entry) {
              items.push({ id: entry.id, quantity: entry.quantity, properties: { _cadeau: 'true' } });
            });

            submit.disabled = true;
            fetch(
              (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js',
              {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: items }),
              }
            )
              .then(function () {
                renderSummary();
                closeModal();
                if (window.Nuya && window.Nuya.cart) return window.Nuya.cart.refresh();
              })
              .catch(function () {})
              .then(function () {
                submit.disabled = false;
                document.dispatchEvent(new CustomEvent('nuya:cart:added', { bubbles: true }));
              });
          }
        });

        /* Changer la taille change la variante ajoutée au panier. */
        modal.addEventListener('change', function (event) {
          var select = event.target.closest('[data-nuya-bundle-variant-select]');
          if (!select) return;

          var card = select.closest('[data-nuya-bundle-card]');
          if (!card) return;

          card.dataset.variant = select.value;
          var option = select.options[select.selectedIndex];
          card.dataset.size = option ? option.textContent.trim() : '';
          refreshState();
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && !modal.hidden) closeModal();
        });
      }

      /* Galerie : une image à la fois — pastilles, balayage tactile et
         clavier. Les noms de variables sont préfixés « gallery » : ce bloc
         partage sa portée avec le carrousel de réassurance plus bas, et un
         « slides » commun ferait pointer la galerie sur les mauvais
         éléments dès que le second bloc s'initialise. */
      var gallery = root.querySelector('[data-nuya-gallery]');
      if (gallery) {
        var gallerySlides = [].slice.call(gallery.querySelectorAll('[data-nuya-slide]'));
        var galleryDots = [].slice.call(gallery.querySelectorAll('[data-nuya-dot]'));
        var galleryIndex = 0;

        function showMedia(next) {
          if (!gallerySlides.length) return;
          galleryIndex = (next + gallerySlides.length) % gallerySlides.length;

          gallerySlides.forEach(function (slide, position) {
            var active = position === galleryIndex;
            slide.classList.toggle('is-active', active);

            /* Une vidéo masquée ne doit pas continuer à jouer. */
            var video = slide.querySelector('video');
            if (video && !active) video.pause();

            /* Les images suivantes ne sont plus différées une fois que le
               visiteur navigue : le changement doit être instantané. */
            var image = slide.querySelector('img[loading="lazy"]');
            if (image) image.loading = 'eager';
          });

          galleryDots.forEach(function (dot, position) {
            var active = position === galleryIndex;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-selected', active ? 'true' : 'false');
          });
        }

        /* Amène au premier visuel rattaché à la variante choisie. */
        function showMediaById(mediaId) {
          if (!mediaId) return;
          for (var i = 0; i < gallerySlides.length; i++) {
            if (gallerySlides[i].dataset.mediaId === String(mediaId)) {
              showMedia(i);
              return;
            }
          }
        }

        gallery.showMediaById = showMediaById;

        gallery.addEventListener('click', function (event) {
          var dot = event.target.closest('[data-nuya-dot]');
          if (!dot) return;
          event.preventDefault();
          showMedia(parseInt(dot.dataset.nuyaDot, 10) || 0);
        });

        /* Flèches du clavier quand la galerie a le focus. */
        gallery.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            showMedia(galleryIndex + 1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            showMedia(galleryIndex - 1);
          }
        });

        /* Balayage tactile : seuil horizontal, on laisse passer le
           défilement vertical de la page. */
        var touchX = null;
        var touchY = null;

        gallery.addEventListener(
          'touchstart',
          function (event) {
            if (event.touches.length !== 1) return;
            touchX = event.touches[0].clientX;
            touchY = event.touches[0].clientY;
          },
          { passive: true }
        );

        gallery.addEventListener(
          'touchend',
          function (event) {
            if (touchX === null) return;

            var touch = event.changedTouches[0];
            var deltaX = touch.clientX - touchX;
            var deltaY = touch.clientY - touchY;

            touchX = null;
            touchY = null;

            if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;
            showMedia(galleryIndex + (deltaX < 0 ? 1 : -1));
          },
          { passive: true }
        );

        showMedia(0);
      }

      /* Réassurance : défilement automatique, arrêté au survol et dès que
         le visiteur choisit un argument. */
      var reassure = root.querySelector('[data-nuya-reassure]');
      if (reassure) {
        var reassureSlides = [].slice.call(reassure.querySelectorAll('[data-nuya-reassure-slide]'));
        var reassureDots = [].slice.call(reassure.querySelectorAll('[data-nuya-reassure-dot]'));
        var reassureIndex = 0;
        var reassureTimer = null;

        function showReassure(next) {
          if (!reassureSlides.length) return;
          reassureIndex = (next + reassureSlides.length) % reassureSlides.length;
          reassureSlides.forEach(function (slide, position) {
            slide.hidden = position !== reassureIndex;
          });
          reassureDots.forEach(function (dot, position) {
            dot.classList.toggle('is-active', position === reassureIndex);
          });
        }

        function playReassure() {
          if (reassureSlides.length < 2) return;
          var delay = (parseInt(reassure.dataset.delay, 10) || 4) * 1000;
          window.clearInterval(reassureTimer);
          reassureTimer = window.setInterval(function () {
            showReassure(reassureIndex + 1);
          }, delay);
        }

        reassureDots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            window.clearInterval(reassureTimer);
            showReassure(parseInt(dot.dataset.nuyaReassureDot, 10) || 0);
          });
        });

        reassure.addEventListener('mouseenter', function () {
          window.clearInterval(reassureTimer);
        });
        reassure.addEventListener('mouseleave', playReassure);

        playReassure();
      }

      render();
    }

    function run(scope) {
      (scope || document).querySelectorAll('[data-nuya-product]').forEach(initProduct);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        run(document);
      });
    } else {
      run(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      run(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuya-search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Le tri s'applique au changement ; sans JavaScript, la touche Entrée
       dans le formulaire fait le même travail. */
    function initSearch(root) {
      if (root.nuyaReady) return;
      root.nuyaReady = true;

      var sort = root.querySelector('[data-nuya-sort]');
      if (!sort) return;

      sort.addEventListener('change', function () {
        var form = sort.closest('form');
        if (form) form.submit();
      });
    }

    function run(scope) {
      (scope || document).querySelectorAll('[data-nuya-search]').forEach(initSearch);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        run(document);
      });
    } else {
      run(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      run(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuya-shoppable-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initShoppable(root) {
      if (root.nuyaReady) return;
      root.nuyaReady = true;

      var carousel = root.querySelector('.nuya-carousel');
      var track = root.querySelector('[data-nuya-track]');

      /* Boucle infinie : on clone quelques cartes à chaque extrémité, et on
         se téléporte d'un tour complet (invisible) quand on entre dans la
         zone clonée. Le carrousel n'a donc plus d'extrémités : toutes les
         cartes réelles peuvent devenir actives, dans les deux sens. */
      var CLONES = 0;
      var realCount = 0;

      if (track) {
        var reals = Array.prototype.slice.call(track.querySelectorAll('.nuya-shoppable__card'));
        realCount = reals.length;

        if (realCount > 1) {
          CLONES = Math.min(realCount, 6);

          for (var i = 1; i <= CLONES; i++) {
            var leftIndex = (realCount - (i % realCount)) % realCount;
            var leftClone = reals[leftIndex].cloneNode(true);
            leftClone.setAttribute('data-clone', 'true');
            track.insertBefore(leftClone, track.firstChild);
          }

          for (var j = 0; j < CLONES; j++) {
            var rightClone = reals[j % realCount].cloneNode(true);
            rightClone.setAttribute('data-clone', 'true');
            track.appendChild(rightClone);
          }
        }
      }

      /* Après clonage : toutes les requêtes incluent les clones (vidéo,
         pause, ajout panier, mise en avant). */
      var cards = root.querySelectorAll('.nuya-shoppable__card');

      /* Vignette produit : une image au hasard parmi celles du produit.
         Chaque carte (clones compris) tire la sienne. */
      root.querySelectorAll('[data-nuya-thumbs]').forEach(function (thumb) {
        var urls = (thumb.dataset.nuyaThumbs || '').split('|').filter(Boolean);
        var img = thumb.querySelector('img');
        if (urls.length < 2 || !img) return;
        img.src = urls[Math.floor(Math.random() * urls.length)];
        img.removeAttribute('srcset');
      });

      /* Lecture : seule la carte active (centrale) joue sa vidéo,
         et seulement quand elle est visible à l'écran. */
      function syncVideo(card) {
        var video = card.querySelector('video');
        if (!video) return;

        var featured = card.dataset.featured === 'true';
        var inview = card.dataset.inview !== 'false';

        if (featured && inview && video.dataset.userPaused !== 'true') {
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        } else {
          video.pause();
        }
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              entry.target.dataset.inview = entry.isIntersecting ? 'true' : 'false';
              syncVideo(entry.target);
            });
          },
          { threshold: 0.4 }
        );

        cards.forEach(function (card) {
          observer.observe(card);
        });
      }

      /* Bouton pause / lecture */
      root.querySelectorAll('[data-nuya-pause]').forEach(function (button) {
        button.addEventListener('click', function () {
          var video = button.closest('.nuya-shoppable__media').querySelector('video');
          if (!video) return;

          var pauseIcon = button.querySelector('[data-nuya-pause-icon]');
          var playIcon = button.querySelector('[data-nuya-play-icon]');

          if (video.paused) {
            video.dataset.userPaused = 'false';
            video.play();
            button.setAttribute('aria-label', button.dataset.labelPause || 'Pause');
          } else {
            video.dataset.userPaused = 'true';
            video.pause();
            button.setAttribute('aria-label', button.dataset.labelPlay || 'Play');
          }

          if (pauseIcon) pauseIcon.hidden = video.paused;
          if (playIcon) playIcon.hidden = !video.paused;
        });
      });

      /* Ajout au panier */
      root.querySelectorAll('[data-nuya-add]').forEach(function (button) {
        button.addEventListener('click', function () {
          var id = parseInt(button.getAttribute('data-nuya-add'), 10);
          if (!id || !window.Nuya) return;

          button.dataset.loading = 'true';

          window.Nuya.cart
            .add(id, 1)
            .then(function () {
              var drawer = document.querySelector('#nuya-cart-drawer');
              if (drawer) window.Nuya.panels.open(drawer);
            })
            .catch(function () {
              window.location.href = '/cart';
            })
            .then(function () {
              button.dataset.loading = 'false';
            });
        });
      });

      /* Mise en avant de la carte centrale + boucle infinie.

         Le défilement programmé n'utilise plus `behavior: 'smooth'` : il est
         interpolé image par image avec un amortissement exponentiel, comme
         le fait Lenis (facteur recalculé à partir du temps écoulé, donc
         identique en 60 et en 120 Hz). Le geste horizontal à la molette ou au
         pavé tactile alimente la même cible : plus de saccade par crans.
         L'animation ne s'appuie sur aucune lecture de layout par image —
         pas, index et états des cartes sont mis en cache. */
      if (track && cards.length) {
        var cardList = Array.prototype.slice.call(cards);
        var stepSize = 0;
        var featuredIndex = -1;
        var highlightQueued = false;
        var animTarget = null;
        var animRaf = null;
        var animLast = 0;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        /* Amortissement par seconde : plus la valeur est haute, plus la
           course est courte. 9 ≈ 200 ms perçus, sans à-coup à l'arrivée. */
        var LAMBDA = 9;

        function now() {
          return window.performance && window.performance.now ? window.performance.now() : Date.now();
        }

        /* Une seule lecture de layout, refaite au redimensionnement. */
        function measure() {
          var gap = parseFloat(window.getComputedStyle(track).columnGap || '0') || 0;
          stepSize = cardList[0].offsetWidth + gap;
        }

        function maxScroll() {
          return Math.max(0, track.scrollWidth - track.clientWidth);
        }

        /* Le snap est débrayé pendant nos animations : il tirerait la
           position à contre-courant de l'interpolation. On atterrit
           exactement sur un point de snap, donc le rétablir ne bouge rien. */
        function setSnap(on) {
          track.style.scrollSnapType = on ? '' : 'none';
        }

        /* Téléportation d'un tour complet (invisible). La cible en cours suit
           le saut, sinon l'animation viserait une position périmée. */
        function jumpTo(left) {
          var delta = left - track.scrollLeft;
          track.scrollLeft = left;
          if (animTarget !== null) animTarget += delta;
        }

        function loopFix() {
          if (!CLONES || !stepSize) return;

          var low = (CLONES - 0.5) * stepSize;
          var high = (CLONES + realCount - 0.5) * stepSize;

          if (track.scrollLeft < low) jumpTo(track.scrollLeft + realCount * stepSize);
          else if (track.scrollLeft > high) jumpTo(track.scrollLeft - realCount * stepSize);
        }

        /* Le padding de centrage garantit que centrer la carte d'index i
           revient à scrollLeft = i × pas : un arrondi remplace la boucle sur
           toutes les cartes et ses lectures de position. */
        function currentIndex() {
          if (!stepSize) return 0;
          return Math.max(0, Math.min(cardList.length - 1, Math.round(track.scrollLeft / stepSize)));
        }

        function highlight() {
          highlightQueued = false;

          var index = currentIndex();
          if (index === featuredIndex) return;
          featuredIndex = index;

          cardList.forEach(function (card, i) {
            var featured = i === index ? 'true' : 'false';
            if (card.dataset.featured !== featured) {
              card.dataset.featured = featured;
              syncVideo(card);
            }

            var adjacent = '';
            if (i === index - 1) adjacent = 'prev';
            else if (i === index + 1) adjacent = 'next';

            if ((card.dataset.adjacent || '') === adjacent) return;
            if (adjacent) card.dataset.adjacent = adjacent;
            else card.removeAttribute('data-adjacent');
          });
        }

        function queueHighlight() {
          if (highlightQueued) return;
          highlightQueued = true;
          window.requestAnimationFrame(highlight);
        }

        function animate(timestamp) {
          if (animTarget === null) {
            animRaf = null;
            return;
          }

          var dt = (timestamp - animLast) / 1000;
          if (!(dt > 0)) dt = 0.016;
          if (dt > 0.064) dt = 0.064;
          animLast = timestamp;

          var current = track.scrollLeft;
          var diff = animTarget - current;

          if (Math.abs(diff) < 0.5) {
            track.scrollLeft = animTarget;
            animTarget = null;
            animRaf = null;
            setSnap(true);
            loopFix();
            return;
          }

          track.scrollLeft = current + diff * (1 - Math.exp(-LAMBDA * dt));
          loopFix();
          animRaf = window.requestAnimationFrame(animate);
        }

        function animateTo(left) {
          var target = Math.max(0, Math.min(maxScroll(), left));

          if (reduceMotion.matches) {
            animTarget = null;
            track.scrollLeft = target;
            loopFix();
            return;
          }

          animTarget = target;
          setSnap(false);

          if (animRaf === null) {
            animLast = now();
            animRaf = window.requestAnimationFrame(animate);
          }
        }

        function stopAnimation() {
          animTarget = null;
          if (animRaf !== null) {
            window.cancelAnimationFrame(animRaf);
            animRaf = null;
          }
          setSnap(true);
        }

        track.addEventListener(
          'scroll',
          function () {
            /* Pendant l'animation, loopFix() est déjà appelé à chaque image. */
            if (animTarget === null) loopFix();
            queueHighlight();
          },
          { passive: true }
        );

        /* Molette et pavé tactile : seul le geste HORIZONTAL est détourné
           (le geste vertical doit continuer à faire défiler la page). Il
           nourrit la même cible interpolée, d'où un défilement continu au
           lieu des crans du défilement natif. */
        track.addEventListener(
          'wheel',
          function (event) {
            var horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!horizontal && !event.shiftKey) return;

            var delta = horizontal ? event.deltaX : event.deltaY;
            if (event.deltaMode === 1) delta *= 16;
            else if (event.deltaMode === 2) delta *= track.clientWidth;
            if (!delta) return;

            event.preventDefault();
            animateTo((animTarget === null ? track.scrollLeft : animTarget) + delta);
          },
          { passive: false }
        );

        /* Un geste au doigt reprend la main sur l'animation en cours. */
        track.addEventListener('touchstart', stopAnimation, { passive: true });

        /* Flèches : navigation par index, jamais désactivées (boucle). */
        function goBy(delta) {
          loopFix();
          if (!stepSize) return;
          var base = animTarget === null ? track.scrollLeft : animTarget;
          animateTo((Math.round(base / stepSize) + delta) * stepSize);
        }

        var prevArrow = carousel ? carousel.querySelector('[data-nuya-prev]') : null;
        var nextArrow = carousel ? carousel.querySelector('[data-nuya-next]') : null;

        if (prevArrow) {
          prevArrow.addEventListener('click', function () {
            goBy(-1);
          });
        }

        if (nextArrow) {
          nextArrow.addEventListener('click', function () {
            goBy(1);
          });
        }

        /* Cliquer une carte inactive la centre, donc l'active. */
        cardList.forEach(function (card, index) {
          card.addEventListener('click', function (event) {
            if (event.target.closest('a, button')) return;
            if (card.dataset.featured === 'true') return;
            loopFix();
            if (stepSize) animateTo(index * stepSize);
            else animateTo(card.offsetLeft + card.offsetWidth / 2 - track.clientWidth / 2);
          });
        });

        /* Redimensionnement : le pas change avec la largeur du carrousel
           (cartes en cqw). On recentre la carte active sur le NOUVEAU pas,
           sinon elle se retrouve à cheval entre deux positions. */
        var resizeTimer = null;

        function remeasure() {
          window.clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(function () {
            var index = currentIndex();
            stopAnimation();
            measure();
            if (stepSize) jumpTo(index * stepSize);
            featuredIndex = -1;
            highlight();
            loopFix();
          }, 120);
        }

        window.addEventListener('resize', remeasure);
        window.addEventListener('load', remeasure);

        if (window.ResizeObserver) {
          new window.ResizeObserver(remeasure).observe(carousel || track);
        }

        /* Départ : première carte réelle centrée, donc active. */
        window.requestAnimationFrame(function () {
          measure();
          if (CLONES && stepSize) jumpTo(CLONES * stepSize);
          highlight();
        });
      }
    }

    function run(scope) {
      (scope || document).querySelectorAll('[data-nuya-shoppable]').forEach(initShoppable);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        run(document);
      });
    } else {
      run(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      run(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuya-slider-immersif"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(root) {
      if (root.nuyaSliderReady) return;
      root.nuyaSliderReady = true;

      var slides = root.querySelectorAll('[data-nuya-slide]');
      var texts = root.querySelectorAll('[data-nuya-text]');
      var thumbs = root.querySelectorAll('[data-nuya-thumb]');
      if (slides.length < 2) return;

      var index = 0;
      var timer = null;
      var delay = (parseInt(root.dataset.delay, 10) || 6) * 1000;
      var autoplay = root.dataset.autoplay === 'true';

      function show(next) {
        index = (next + slides.length) % slides.length;

        slides.forEach(function (slide, position) {
          var on = position === index;
          slide.classList.toggle('is-active', on);
          if (on) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });

        texts.forEach(function (text, position) {
          var on = position === index;
          text.classList.toggle('is-active', on);
          if (on) text.removeAttribute('aria-hidden');
          else text.setAttribute('aria-hidden', 'true');
        });

        thumbs.forEach(function (thumb, position) {
          var on = position === index;
          thumb.classList.toggle('is-active', on);
          thumb.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      /* Le défilement automatique repart de zéro à chaque interaction : le
         visiteur n'est jamais bousculé pendant qu'il regarde une vue. */
      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        if (!autoplay) return;
        timer = window.setInterval(function () {
          show(index + 1);
        }, delay);
      }

      root.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-nuya-thumb]');
        if (!thumb) return;
        event.preventDefault();
        show(parseInt(thumb.dataset.nuyaThumb, 10) || 0);
        start();
      });

      root.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        if (!event.target.closest('[data-nuya-thumb]')) return;
        event.preventDefault();
        show(index + (event.key === 'ArrowRight' ? 1 : -1));
        start();
        if (thumbs[index]) thumbs[index].focus();
      });

      /* Balayage tactile sur le visuel. */
      var startX = null;
      root.addEventListener(
        'touchstart',
        function (event) {
          startX = event.changedTouches[0].clientX;
        },
        { passive: true }
      );

      root.addEventListener(
        'touchend',
        function (event) {
          if (startX === null) return;
          var travel = event.changedTouches[0].clientX - startX;
          startX = null;
          if (Math.abs(travel) < 40) return;
          show(index + (travel < 0 ? 1 : -1));
          start();
        },
        { passive: true }
      );

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      /* Rien ne tourne quand la section est hors écran ou l'onglet caché. */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) start();
            else stop();
          });
        }).observe(root);
      } else {
        start();
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      show(0);
    }

    function run(scope) {
      (scope || document).querySelectorAll('[data-nuya-slider]').forEach(initSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        run(document);
      });
    } else {
      run(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      run(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuya-soin-du-detail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDetail(root) {
      if (root.nuyaReady) return;
      root.nuyaReady = true;

      var points = root.querySelectorAll('.nuya-detail__point');
      var frame = root.querySelector('.nuya-detail__media');

      /* Sous 750 px le panneau devient une carte modale posée en bas de
         l'écran : plus de calage dans le cadre de l'image. */
      var mqModal = window.matchMedia('(max-width: 749px)');

      function syncOpenFlag() {
        var any = false;
        points.forEach(function (point) {
          if (point.dataset.open === 'true') any = true;
        });
        root.dataset.anyOpen = any ? 'true' : 'false';
      }

      function setOpen(point, state) {
        point.dataset.open = state ? 'true' : 'false';
        var button = point.querySelector('.nuya-detail__dot');
        if (button) button.setAttribute('aria-expanded', state ? 'true' : 'false');
        syncOpenFlag();
      }

      /* Le panneau ne doit JAMAIS déborder du cadre de l'image.
         1. On repart du côté d'origine et sans décalage.
         2. Si le côté déborde, on essaie l'autre côté.
         3. Quoi qu'il reste, on recale au pixel près dans le cadre
            via --shift-x / --shift-y (consommés par le transform CSS). */
      /* Mode modal : la carte est centrée sur l'image. Elle reste enfant du
         point (donc positionnée par rapport à lui), on calcule donc l'écart
         en pixels entre le coin du point et la position voulue. */
      function positionModal(point) {
        var panel = point.querySelector('.nuya-detail__panel');
        if (!panel || !frame) return;

        var media = frame.getBoundingClientRect();
        var margin = 12;

        panel.style.setProperty('--modal-w', Math.max(160, Math.min(300, media.width - margin * 2)) + 'px');
        panel.style.setProperty('--modal-max-h', Math.max(120, media.height - margin * 2) + 'px');

        /* Mesure APRÈS avoir fixé largeur et hauteur maximale. */
        var pointRect = point.getBoundingClientRect();
        var panelW = panel.offsetWidth;
        var panelH = panel.offsetHeight;

        var left = media.left + (media.width - panelW) / 2;
        var top = media.top + (media.height - panelH) / 2;

        left = Math.max(media.left + margin, Math.min(left, media.right - panelW - margin));
        top = Math.max(media.top + margin, Math.min(top, media.bottom - panelH - margin));

        panel.style.setProperty('--modal-x', Math.round(left - pointRect.left) + 'px');
        panel.style.setProperty('--modal-y', Math.round(top - pointRect.top) + 'px');
      }

      function clamp(point) {
        var panel = point.querySelector('.nuya-detail__panel');
        if (!panel || !frame) return;

        if (mqModal.matches) {
          panel.style.setProperty('--shift-x', '0px');
          panel.style.setProperty('--shift-y', '0px');
          positionModal(point);
          return;
        }

        if (!point.dataset.baseSide) point.dataset.baseSide = point.getAttribute('data-side');
        point.setAttribute('data-side', point.dataset.baseSide);
        panel.style.setProperty('--shift-x', '0px');
        panel.style.setProperty('--shift-y', '0px');

        var frameRect = frame.getBoundingClientRect();
        var rect = panel.getBoundingClientRect();

        var side = point.getAttribute('data-side');
        if (side === 'right' && rect.right > frameRect.right) {
          point.setAttribute('data-side', 'left');
        } else if (side === 'left' && rect.left < frameRect.left) {
          point.setAttribute('data-side', 'right');
        }

        rect = panel.getBoundingClientRect();

        var shiftX = 0;
        if (rect.left < frameRect.left) shiftX = frameRect.left - rect.left;
        else if (rect.right > frameRect.right) shiftX = frameRect.right - rect.right;
        if (shiftX) panel.style.setProperty('--shift-x', shiftX + 'px');

        var shiftY = 0;
        if (rect.top < frameRect.top) shiftY = frameRect.top - rect.top;
        else if (rect.bottom > frameRect.bottom) shiftY = frameRect.bottom - rect.bottom;
        if (shiftY) panel.style.setProperty('--shift-y', shiftY + 'px');
      }

      function clampOpen() {
        points.forEach(function (point) {
          if (point.dataset.open === 'true' || point.matches(':hover')) clamp(point);
        });
      }

      function closeAll(except) {
        points.forEach(function (point) {
          if (point === except) return;
          point.dataset.open = 'false';
          var button = point.querySelector('.nuya-detail__dot');
          if (button) button.setAttribute('aria-expanded', 'false');
        });
        syncOpenFlag();
      }

      points.forEach(function (point) {
        var button = point.querySelector('.nuya-detail__dot');
        if (!button) return;

        /* Le clic n'ouvre QUE en mode modal (mobile) : sur desktop la bulle
           s'ouvre au survol seul (CSS `.nuya-detail__point:hover`), un clic
           ne doit donc rien basculer.
           Un clic sur un autre point ferme le précédent et ouvre le nouveau :
           closeAll() d'abord, bascule ensuite. */
        button.addEventListener('click', function (event) {
          event.stopPropagation();
          if (!mqModal.matches) return;
          var isOpen = point.dataset.open === 'true';
          closeAll(point);
          setOpen(point, !isOpen);
          if (!isOpen) clamp(point);
        });

        /* Ouverture au focus réservée au CLAVIER. Sans ce garde-fou, le focus
           déclenché par le clic ouvre le point juste avant que le clic ne le
           referme — au survol on ne voyait rien, sans survol (mobile) le
           panneau ne s'ouvrait jamais. */
        button.addEventListener('focus', function () {
          if (typeof button.matches !== 'function' || !button.matches(':focus-visible')) return;
          closeAll(point);
          setOpen(point, true);
          clamp(point);
        });

        point.addEventListener('mouseenter', function () {
          clamp(point);
        });

        /* L'image du panneau charge en différé : sa hauteur change,
           on recale une fois chargée. */
        point.querySelectorAll('.nuya-detail__panel img').forEach(function (img) {
          if (img.complete) return;
          img.addEventListener('load', clampOpen);
        });
      });

      window.addEventListener('resize', clampOpen);

      /* Changement de mode bulle ↔ modal : on referme et on repart propre. */
      if (mqModal.addEventListener) {
        mqModal.addEventListener('change', function () {
          closeAll(null);
        });
      }

      root.querySelectorAll('[data-nuya-detail-close]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.stopPropagation();
          closeAll(null);
        });
      });

      /* Un clic n'importe où ailleurs ferme : le voile, l'image, le texte de
         la section ou le reste de la page. Seul l'intérieur d'un point
         (donc de sa carte ouverte) est épargné. */
      document.addEventListener('click', function (event) {
        if (!event.target || typeof event.target.closest !== 'function') return;
        if (event.target.closest('.nuya-detail__point')) return;
        closeAll(null);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeAll(null);
      });

      syncOpenFlag();
    }

    function run(scope) {
      (scope || document).querySelectorAll('[data-nuya-detail]').forEach(initDetail);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        run(document);
      });
    } else {
      run(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      run(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
